import type { Store } from '@types'

function catalogStillInUse(store: Store, catalogKey: string): boolean {
  for (const item of store.items.values()) {
    if (String(item.catalogID) === catalogKey) return true
    const codigo = (item as { codigo?: string }).codigo
    if (codigo != null && String(codigo) === catalogKey) return true
  }
  return false
}

/**
 * Quita de sceneGLB solo si ningún item del proyecto sigue usando ese código.
 * CORTEKIT y muebles normales: misma regla (no borrar la caché de otros padres).
 */
export function purgeSceneGlbForCatalog(
  store: Store,
  catalogID?: string | number | null,
  codigo?: string | null,
): void {
  const keys = new Set<string>()
  if (catalogID != null && catalogID !== '') keys.add(String(catalogID))
  if (codigo != null && codigo !== '') keys.add(String(codigo))

  keys.forEach((key) => {
    if (!catalogStillInUse(store, key)) {
      store.sceneGLB.delete(key)
    }
  })
}
